import AutomationRenameDialog from './AutomationRenameDialog'

export default AutomationRenameDialog
